import { Controller } from "@hotwired/stimulus"

/**
 * Dialogue Script Controller
 *
 * Manages dialogue characters and lines for the scripted video dialogue editor.
 * Saves changes back to the server via PATCH to update config_data.
 */
export default class extends Controller {
  static targets = ["character"]
  static values = { configId: String }

  addCharacter() {
    const id = `char-${crypto.randomUUID().slice(0, 8)}`
    this.saveDialogueUpdate({
      action: "add_character",
      character: { id, name: `Character ${this.characterTargets.length + 1}` }
    })
  }

  removeCharacter(event) {
    const charId = event.currentTarget.dataset.characterId
    if (!charId) return

    if (!window.confirm("Remove this character? Their dialogue lines will also be removed.")) return

    this.saveDialogueUpdate({ action: "remove_character", character_id: charId })
  }

  updateCharacter(event) {
    const charId = event.target.dataset.characterId
    const name = event.target.value
    if (!charId) return

    this.saveDialogueUpdate({ action: "update_character", character_id: charId, name })
  }

  updateCharacterVoice(event) {
    const charId = event.target.dataset.characterId
    const voiceProfileId = event.target.value
    if (!charId) return

    this.saveDialogueUpdate({
      action: "update_character_voice",
      character_id: charId,
      voice_profile_id: voiceProfileId
    })
  }

  async saveDialogueUpdate(data) {
    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const url = `/scripted_video_configs/${this.configIdValue}/update_dialogue`

      await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify(data)
      })

      // Reload to show updated state
      if (typeof Turbo !== "undefined" && Turbo.visit) {
        Turbo.visit(window.location.href, { action: "replace" })
      } else {
        window.location.reload()
      }
    } catch (error) {
      console.error("[dialogue-script] Save failed:", error)
    }
  }
}
